<template>
  <div>
    <div v-if="loading">
      <amenity-manatee-loading></amenity-manatee-loading>
    </div>
    <div v-else>
        <td>{{ this.billingRampPeriod.SequenceNumber }}</td>
        <td>{{ this.billingRampPeriod.Percentage }}%</td>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    billing_ramp_period_id: {
      required: true,
      type: Number,
    },
    billing_ramp_period: {
      required: false,
      type: Object,
      default: null,
    }
  },
  mounted() {
    this.loadBillingRampPeriod()
  },

  methods: {
    toggleCollapse() {
      this.collapseSection = !this.collapseSection;
    },
    beforeLoad() {
      return this.loadBillingRampPeriod();
    },
    loadBillingRampPeriod() {
      if (this.billing_ramp_period !== null && this.billingRampPeriod === null) {
        this.$set(this, "billingRampPeriod", this.billing_ramp_period);
        this.loading = false;
        return function () { return; };
      }
      var url = "/core/billingRampPeriod/" + this.billing_ramp_period_id;
      //console.log(url);
      return axios.get(url).then((response) => {
        console.log(response.data.BillingRampPeriod);
        this.$set(this, "billingRampPeriod", response.data.BillingRampPeriod);
        this.loading = false;
      }).catch(this.$root.handleErrors)
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {},
  data() {
    return {
      collapseSection: true,
      loading: true,
      billingRampPeriod: null,
    };
  },
};
</script>
